<div class="container">
  <h1 class="page-title"><span class="icon"><i class="fas fa-truck"></i></span>{{ 'DOQuery.Detail.Header' | translate }}
  </h1>
  <p-card>
    <form class="detail-form">
      <div class="field grid">
        <div class="p-fluid field grid">
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.LetterHeadComp' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.letterHeadOrgId | optionsMapping:letterHeadOptions | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.ShipOutComp' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.shipCorp | optionsMapping:letterHeadOptions | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.LoadOrderComp' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.orgId | optionsMapping:orgIdList | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.CustomerCode' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.consigneeKey | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.CustomerName' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.consigneeCompany | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.Priority' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.priority| optionsMapping:priorityOptions | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.TradeTerm' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.incoTerm | optionsMapping:incoTermOptions | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.ETD' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.etd | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.ETA' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.eta | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.DeliveryLocate' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.deliveryType | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.DeliveryMode' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.dischargeType | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.ShipAddr' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.shipToAddress | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ "DOQuery.Form.Column.DeliveryToCity" | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.deliveryToCity | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ "DOQuery.Form.Column.DeliveryToCounty" | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.deliveryToCounty | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ "DOQuery.Form.Column.DeliveryToAddress1" | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.deliveryToAddress1 | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.NormalizationAddress' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.normalizationAddress | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.GroupId' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.normalizationGroupId | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.DeliveryTo' | translate }}</label>
            <div class="col-8 column-value">
              <div *ngIf="!isSaveEditBtn">{{ doModel?.deliveryToAddress | replaceNullWith:'-' }}</div>
              <p-dropdown name="deliveryTo" [options]="consigneeAddressOptions" [(ngModel)]="deliveryTo" (ngModelChange)="onChange()"
              [showClear]="true" *ngIf="editDeliveryTo" [placeholder]="'請選擇'" [filter]="true"
              styleClass="p-text-left" (keydown)="onDropdownKeydown($event)">
            </p-dropdown>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.ShippingInstruct' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.shipNotes | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.TotalCartonCnt' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.cartonCnt | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.NetWeight' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.totalNetWeight | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.GrossWeight' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.totalGrossWeight | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.VolumeWeight' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.volumeWeight | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.PaymentTerm' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.paymentTerm | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.Storer' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.storer | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.Group' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.tenant | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.InvoiceNo' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.invoiceNo | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.InvoiceDT' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.invoiceDate | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone |
              replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.WaitingReference' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.waitingReason | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.OnHoldReason' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.noShippingReason | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.CSR' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.csr | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.Sales' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.salesCode | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.Department' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.dept | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.DOStatus' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.doStatus | optionsMapping:DOStatusOptions | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.OutercaseArrivalDate' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.outercaseArrivalDate | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone |
              replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.LoadingDate' | translate }}</label>
            <div class="col-8 column-value">
              <ng-container *ngIf="doModel?.loadingDate !== '-'">
                {{ doModel?.loadingDate | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone }}
              </ng-container>
              <ng-container *ngIf="doModel?.loadingDate === '-'">
                {{ doModel?.loadingDate }}
              </ng-container>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.LeaveDate' | translate }}</label>
            <div class="col-8 column-value">
              <ng-container *ngIf="doModel?.leaveDate !== '-'">
                {{ doModel?.leaveDate | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone }}
              </ng-container>
              <ng-container *ngIf="doModel?.leaveDate === '-'">
                {{ doModel?.leaveDate }}
              </ng-container>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.DOBookStatus' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.doBookingStatus| optionsMapping:DOBookingStatusOptions | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.DropShipFlag' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.isDropRemark | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.BookingNum' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.bookingNo | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.BookingForwarder' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.bookingForwarder | optionsMapping:bookingForwarderOptions | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.AssignForwarder' | translate }}</label>
            <div class="col-8 column-value">
              <div *ngIf="!isSaveEditBtn">{{ doModel?.assignForwarder | optionsMapping:assignForwarderOptions | replaceNullWith:'-' }}</div>
              <p-dropdown name="assignForwarderCode" [options]="assignForwarderOptions" [(ngModel)]="assignForwarderCode"
                [showClear]="true" *ngIf="isSaveEditBtn" [placeholder]="'請選擇'"
                styleClass="p-text-left" (keydown)="onDropdownKeydown($event)">
              </p-dropdown>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.AssignDate' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.assignDate | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.Facility' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.facility | optionsMapping:facilityOptions | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.BOLCnt' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.bookingCount | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.License' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.license | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.SKU' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.sku | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.Brand' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.brand | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.IsConfirm' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.isConfirm | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.ExtraWorkStatus' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.extraWorkStatus | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.MergeKey' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.mergeKey | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.DONum' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.doNo | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.InvoiceRemark' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.invoiceRemark | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.AssignmentInvoiceDt' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.assignmentInvoiceDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone |
              replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.ConsolidationId' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.consolidationId | replaceNullWith:'-' }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'DOQuery.Form.Column.CreateDtMO' | translate }}</label>
            <div class="col-8 column-value">
              {{ doModel?.createDtMO | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone |
              replaceNullWith:'-' }}
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col">
            <button *ngIf="isShowEditBtn && !['J', 'K', 'C', 'P', 'O'].includes(this.doModel?.doStatus)" pButton pRipple label="{{ 'Common.Button.Edit' | translate }}"
              (click)="editBtnClick($event)" class="mr-2"></button>
            <button *ngIf="isSaveEditBtn" pButton pRipple label="{{ 'Common.Button.Save' | translate }}"
              (click)="saveBtnClick($event)" class="mr-2"></button>
            <button *ngIf="isCancelEditBtn" pButton pRipple label="{{ 'Common.Button.Cancel' | translate }}"
              (click)="cancelBtnClick($event)" class="p-button-secondary ml-2"></button>
          </div>
        </div>
      </div>
    </form>
  </p-card>
</div>
